import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGQuickPay from "../../../assets/img/SolutionsIcons/AgilysysIGQuickPay.svg";
import { Header } from "../../../components/Header";

const IGQuickPayFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash IGQuickPayFPage">
            <div className="page-title"><img src={IGQuickPay} alt=""/></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A cloud-native touchless payment experience allowing
residents to use their own mobile device to scan a QR code on
the InfoGenesis check linking to a digital copy of the check
where they can review it, add a tip & initiate payment.{'\n\n'}
                </div>
                <div className="std-text">
                The result is a streamlined, fully contactless payment process
that protects the health of residents and staff alike, while
helping to speed table turnover.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - IG Quick Pay", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)
                }}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGQuickPay.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveIGQuickPay.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default IGQuickPayFPage;